if (!customElements.get("product-swatches")) {
  class ProductSwatches extends HTMLElement {
    constructor() {
      super();
    }

    handleChange(event) {
      this.dispatchEvent(
        new CustomEvent("alexa:swatch-change", {
          detail: {
            color: event.target.value,
            colorText: event.target.dataset.value
          },
          bubbles: true,
        })
      );
    }

    connectedCallback() {
      this.addEventListener("change", this.handleChange.bind(this));
    }
  }
  customElements.define("product-swatches", ProductSwatches);
}
